"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _trimStart = _interopRequireDefault(require("lodash/trimStart"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Contacts = require("../Contacts");

var _ContactPoper = _interopRequireDefault(require("../ContactPoper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MAX_SUGGESTION_NUMBER = 6;
var MIN_INPUT_WIDTH = 50;

function RecipientInput(_ref, ref) {
  var _ref$contacts = _ref.contacts,
      contacts = _ref$contacts === void 0 ? [] : _ref$contacts,
      _ref$getRecipientAvat = _ref.getRecipientAvatar,
      getRecipientAvatar = _ref$getRecipientAvat === void 0 ? _noop["default"] : _ref$getRecipientAvat,
      _ref$defaultRecipient = _ref.defaultRecipient,
      defaultRecipient = _ref$defaultRecipient === void 0 ? null : _ref$defaultRecipient,
      _ref$onChangeRecipien = _ref.onChangeRecipient,
      onChangeRecipient = _ref$onChangeRecipien === void 0 ? _noop["default"] : _ref$onChangeRecipien,
      _ref$onBackspace = _ref.onBackspace,
      onBackspace = _ref$onBackspace === void 0 ? _noop["default"] : _ref$onBackspace,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur,
      _ref$containerRef = _ref.containerRef,
      containerRef = _ref$containerRef === void 0 ? _noop["default"] : _ref$containerRef,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["contacts", "getRecipientAvatar", "defaultRecipient", "onChangeRecipient", "onBackspace", "onBlur", "containerRef", "className"]);

  var _useState = (0, _react.useState)(defaultRecipient ? defaultRecipient.email : ''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var isImeOpenRef = (0, _react.useRef)(false);
  var contactsRef = (0, _react.useRef)([]);

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      escaped = _useState6[0],
      setEscaped = _useState6[1];

  var inputRef = (0, _react.useRef)();
  var autoSizeCallback = (0, _react.useCallback)(function () {
    if (inputRef.current && containerRef.current) {
      inputRef.current.style.width = "".concat(MIN_INPUT_WIDTH, "px");

      if (inputRef.current.scrollWidth > inputRef.current.offsetWidth) {
        var maxWidth = containerRef.current.offsetWidth - 8;
        var currWidth = inputRef.current.scrollWidth;
        inputRef.current.style.width = "".concat(Math.min(maxWidth, currWidth), "px");
      }
    }
  }, []);
  var resizeCallback = (0, _react.useCallback)(function () {
    if (inputRef.current) {
      inputRef.current.style.width = "".concat(MIN_INPUT_WIDTH, "px");
    }
  }, []);
  var matchedContacts = (0, _react.useMemo)(function () {
    var matches = [];

    for (var index = 0; !!value && matches.length < MAX_SUGGESTION_NUMBER && index < contacts.length; index++) {
      var each = contacts[index];

      if ([each.name, each.email].join(' ').toLowerCase().includes(value.toLowerCase())) {
        matches.push(each);
      }
    }

    return matches.sort(function (a, b) {
      return a.name < b.name ? -1 : 1;
    });
  }, [contacts, value]);
  (0, _react.useEffect)(function () {
    if (matchedContacts.length) {
      setSelected(0);
    }
  }, [matchedContacts]);
  (0, _react.useEffect)(function () {
    setEscaped(false);
  }, [value]);
  (0, _react.useEffect)(function () {
    var eventListener = null;
    document.addEventListener('visibilitychange', eventListener = function eventListener() {
      if (document.visibilityState === 'hidden') {
        isImeOpenRef.current = false;
      }
    });
    return function () {
      document.removeEventListener('visibilitychange', eventListener);
    };
  }, []);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        return inputRef.current.focus();
      },
      blur: function blur() {
        return inputRef.current.blur();
      },
      select: function select() {
        return inputRef.current.select();
      },
      clearValue: function clearValue() {
        return setValue('');
      },
      resize: resizeCallback
    };
  });

  function handleBlur(e) {
    //Blur event is trigger after visibilitychange, so need setTimeout to check
    setTimeout(function () {
      if (document.visibilityState === 'visible') {
        var realValue = value.trim();

        if (matchedContacts[selected] && matchedContacts[selected].email === realValue) {
          onChangeRecipient(matchedContacts[selected]);
        } else {
          onChangeRecipient(realValue ? {
            name: '',
            email: realValue
          } : null);
        }
      }
    });
    onBlur(e);
  }

  function handleOnKeyDown(e) {
    if (isImeOpenRef.current) return;

    switch (e.key) {
      case 'Backspace':
        if (!value.trim()) {
          onBackspace();
        }

        break;

      case ',':
      case ';':
      case 'Enter':
        e.preventDefault();

        if (value.trim()) {
          var selectedContact = matchedContacts[selected];
          onChangeRecipient((0, _isNil["default"])(selectedContact) ? {
            name: '',
            email: value.trim()
          } : selectedContact);
        }

        break;

      case 'Tab':
        if (value.trim()) {
          e.preventDefault();
          var _selectedContact = matchedContacts[selected];
          onChangeRecipient((0, _isNil["default"])(_selectedContact) ? {
            name: '',
            email: value.trim()
          } : _selectedContact);
        }

        break;

      case 'ArrowDown':
        {
          e.preventDefault();
          var newSelected = selected + 1;
          setSelected(newSelected < matchedContacts.length - 1 ? newSelected : matchedContacts.length - 1);
          var node = contactsRef.current[newSelected];
          node && node.scrollIntoView({
            block: 'nearest'
          });
          break;
        }

      case 'ArrowUp':
        {
          e.preventDefault();

          var _newSelected = selected - 1;

          setSelected(_newSelected > -1 ? _newSelected : 0);
          var _node = contactsRef.current[_newSelected];
          _node && _node.scrollIntoView({
            block: 'nearest'
          });
          break;
        }

      case 'Escape':
        if (value.trim()) {
          //escape in some modal need stop the event.
          e.stopPropagation();

          if (matchedContacts.length) {
            setEscaped(true);
          }
        }

        break;

      default:
        break;
    }
  }

  (0, _react.useEffect)(function () {
    value.trim().length ? autoSizeCallback() : resizeCallback();
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
    ref: inputRef,
    className: (0, _classnames["default"])("m-1 text-dark h-8 text-sm bg-transparent", className),
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    value: value,
    onPaste: function onPaste(e) {
      var _e$clipboardData;

      var pastedText = (e === null || e === void 0 ? void 0 : (_e$clipboardData = e.clipboardData) === null || _e$clipboardData === void 0 ? void 0 : _e$clipboardData.getData('Text')) || '';

      if (!(pastedText === null || pastedText === void 0 ? void 0 : pastedText.includes(',')) && !(pastedText === null || pastedText === void 0 ? void 0 : pastedText.includes(';'))) {
        return;
      }

      e.preventDefault();
      var emails = pastedText.split(/[,;]/).map(function (item) {
        return item.trim();
      }).filter(Boolean);
      emails[0] = "".concat(value).concat(emails[0]);
      var recipients = emails.map(function (email) {
        return contacts.find(function (contactItem) {
          return contactItem.email === email;
        }) || {
          name: '',
          email: email
        };
      });
      recipients.length && onChangeRecipient.apply(void 0, (0, _toConsumableArray2["default"])(recipients));
    },
    onChange: function onChange(e) {
      setValue((0, _trimStart["default"])(e.target.value));
    },
    onKeyDown: handleOnKeyDown,
    onBlur: handleBlur,
    onCompositionStart: function onCompositionStart() {
      return isImeOpenRef.current = true;
    },
    onCompositionEnd: function onCompositionEnd() {
      return isImeOpenRef.current = false;
    },
    style: _objectSpread({
      //auto scale width
      minWidth: MIN_INPUT_WIDTH,
      maxWidth: '100%'
    }, props.style)
  })), /*#__PURE__*/_react["default"].createElement(_ContactPoper["default"], {
    anchorEl: containerRef.current,
    contacts: escaped ? [] : matchedContacts.map(function (each, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: each.email,
        ref: function ref(node) {
          return contactsRef.current[index] = node;
        },
        className: (0, _classnames["default"])("outline-none px-4 py-1", {
          'bg-secondary': selected === index
        }),
        onMouseEnter: function onMouseEnter() {
          return setSelected(index);
        },
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
          onChangeRecipient(each);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Contacts.Contact, (0, _extends2["default"])({}, each, {
        avatar: getRecipientAvatar(each),
        highlightWord: value
      })));
    })
  }));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(RecipientInput);

exports["default"] = _default;
//# sourceMappingURL=RecipientInput.js.map